import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import {Notification} from "element-ui";
import {Input} from "element-ui";

Vue.config.productionTip = false
Vue.use(Input);

Vue.prototype.$notify = Notification;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
